<template>
  <div class="rankingList" v-loading="loading">
      <div class="rankingList_title">
          <div class="rankingList_title_start">序号</div>
          <div class="rankingList_title_center">姓名</div>
          <div class="rankingList_title_end">答对数量</div>
      </div>
      <div class="rankingList_content" v-for="(item,index) in topExercise" :key="index">
          <div class="rankingList_content_index" v-if="index < 3">{{index + 1}}</div>
          <div class="rankingList_content_index_else" v-else>{{index + 1}}</div>
          <div class="rankingList_title_center">{{item.studentName}}</div>
          <div class="rankingList_title_end">{{item.correctCount}}</div>
      </div>
      <div v-if="topExercise.length == 0">
          <div class="rankingList_none">暂无数据</div>
      </div>
  </div>
</template>

<script>

export default {
    props: {
        typeId: ''
    },
  data() {
    return {
        loading: true,
        searchForm: {
            type: 'practice',
            typeId: '',
            topCount: 0
        },
        topExercise: []
    };
  },
  created() {},
  methods: {
      getTopExerciseListByTypeId(){
          this.searchForm.typeId = this.typeId
          this.api.practice.getTopExerciseListByTypeId(this.searchForm).then(result=>{
              if(result.success){
                  this.topExercise = result.data;
                  this.loading = false;
              }else{
                  this.$message.error(result.message)
                  this.loading = false;
              }
          })
      }
  },
  mounted(){
      this.getTopExerciseListByTypeId()
  },
  watch: {
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.rankingList_title{
    display: flex;
    justify-content: space-between;
    color: #4d94ff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #cccccc;
}
.rankingList_content{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    line-height: 37px;
}
.rankingList_title_start{
    width: 35px;
    text-align: center;
}
.rankingList_title_center{
    width: 120px;
    text-align: center;
}
.rankingList_title_end{
    width: 60px;
    text-align: center;
}
.rankingList_content_index{
    color: #fd2525;
    border: 1px solid #cccccc;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
}
.rankingList_content_index_else{
    width: 35px;
    line-height: 35px;
    text-align: center;
}
.rankingList_none{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/rankingList.vue